<ng-template #sidePanelTarget></ng-template>